/* eslint-disable max-len */
export const rootConfig = {
  apiRoot: 'https://mmsalpha.vistrian.com/MMSAPIDemoClient/api/User',

  apiRoot1: 'https://mmsalpha.vistrian.com/MMSAPIDemoClient/api',
  apiRoot2: 'https://mmsalpha.vistrian.com/CMMSDemoClient/api',

  baseUrl: 'http://vistrian2.panorbitprojects.com/api',
  baseUrl2: 'https://vistrian-backend-2.panorbitprojects.com/api' // For Localization
};

export const apiEndPoints = {
  login: `${rootConfig.apiRoot2}/login/`,
  authenticate: `${rootConfig.apiRoot}/Authenticate`,
  forgotPassword: `${rootConfig.apiRoot}/ForgotPassword/`,
  ResetUserPassword: `${rootConfig.apiRoot}/ResetPassword`,
  ValidateCode: `${rootConfig.baseUrl}/ValidateCode/`,
  ResetPassword: `${rootConfig.baseUrl}/ResetPassword/`,
  ChangePassword: `${rootConfig.apiRoot}/ChangePassword`,
  getMenu: `${rootConfig.apiRoot1}/User/GetUserMenus/`,
  CarouselData: `${rootConfig.apiRoot2}/getCarouselData`,
  notifcationData: `${rootConfig.apiRoot2}/getBannerNotifications`,
  localStringsData: `${rootConfig.apiRoot2}/getLocaleString`,
  getTheme: `${rootConfig.apiRoot2}/getTheme/`,
  updatePageUsageStatistics: `${rootConfig.apiRoot}/updatePageUsageStatistics`,

  getActionItems: `${rootConfig.apiRoot2}/WF/GetActionItems`,
  getWorkOrders: `${rootConfig.apiRoot2}/WF/listWorkOrders`,

  getWorkOrdersCountByGroup: `${rootConfig.apiRoot2}/WF/GetWorkOrdersCountByGroup`,
  getWorkOrdersWithoutUserFilter: `${rootConfig.apiRoot2}/wf/listWorkOrdersWithoutUserFilter`,

  getWorkflowTypes: `${rootConfig.apiRoot2}/WF/getWorkflowTypes`,
  getFormStructure: `${rootConfig.apiRoot2}/WF/getFormStructure/`,
  getWorkOrderDetails: `${rootConfig.apiRoot2}/WF/getFormDetails/`,
  getSparesFilters: `${rootConfig.apiRoot2}/WF/GetSparesFilters`,
  getFilterCategory: `${rootConfig.apiRoot}/getFilterCategory/`,
  getFilterCategory2: `${rootConfig.apiRoot}/getFilterCategory/`,
  // getFilterCategory: `${rootConfig.apiRoot1}/User/getFilterCategory/`
  getSparesList: `${rootConfig.apiRoot2}/WF/getSparesList`,
  getSpareDetails: `${rootConfig.apiRoot2}/WF/getSpareDetails/`,
  getFilterByWOType: `${rootConfig.apiRoot1}/User/GetFiltersByTemplateID`,
  getAssetsList: `${rootConfig.apiRoot1}/User/getAssetsList/`,
  // getAssetsList: `${rootConfig.apiRoot2}/WF/getAssetsList/`,
  getUserDataByTemplateId: `${rootConfig.apiRoot2}/WF/GetUserDataByTemplateID`,
  getUserDataByTemplateId2: `${rootConfig.apiRoot2}/WF/GetUserDataByTemplateID`,

  // getGraphURI: `${rootConfig.baseUrl}/getGraphURI/`
  getGraphURI: `${rootConfig.apiRoot1}/User/getGraphURI/`,

  getSchedule: `${rootConfig.apiRoot1}/Schedule/GetSchedules`,
  getScheduleDetails: `${rootConfig.apiRoot1}/Schedule/GetAnySchedulenew`,
  createSchedule: `${rootConfig.apiRoot1}/Schedule/CreateSchedule`,
  scheduleFormStructure: `${rootConfig.apiRoot1}/Schedule/GetSchedulesFormStructure`,
  updateSchedule: `${rootConfig.apiRoot1}/Schedule/UpdateSchedule`,
  updatePlan: `${rootConfig.apiRoot1}/Schedule/UpdatePlan`,

  // Spares BUlk Update
  getSparesOptions: `${rootConfig.apiRoot1}/user/GetBulkSpareProfiles`,
  getSparesOptionsIndividual: `${rootConfig.apiRoot1}/user/GetBulkAnySpareProfile`,
  getBulkSpareProfileDocuments: `${rootConfig.apiRoot1}/user/GetBulkSpareProfileDocuments`,

  // Work order IDM
  getIdmFilters: `${rootConfig.apiRoot1}/User/GetFiltersByTemplateID`,
  getIdmFilterDetails: `${rootConfig.apiRoot1}/User/getIDMDetails`,

  // Activity
  getActivity: `${rootConfig.apiRoot1}/Schedule/GetActivities`,
  getActivityDetails: `${rootConfig.apiRoot1}/Schedule/GetAnyActivity/`,
  createActivity: `${rootConfig.apiRoot1}/Schedule/CreateActivity`,
  updateActivity: `${rootConfig.apiRoot1}/Schedule/UpdateActivity`,
  getWorkflowTypesForActivity: `${rootConfig.apiRoot1}/Schedule/GetWorkflowTypes`,

  // scheduleType
  getScheduleType: `${rootConfig.apiRoot1}/Schedule/GetScheduleTypes`,
  CreateScheduleType: `${rootConfig.apiRoot1}/Schedule/CreateScheduleType`,
  UpdateScheduleType: `${rootConfig.apiRoot1}/Schedule/UpdateScheduleType`,
  getScheduleTypeDetails: `${rootConfig.apiRoot1}/Schedule/GetAnyScheduleType`,

  // plan
  getScheduleList: `${rootConfig.apiRoot1}/Schedule/GetScheduleList`,
  getSchedulePlan: `${rootConfig.apiRoot1}/Schedule/GetScheduleList`,
  getSchedulePlanDetails: `${rootConfig.apiRoot1}/Schedule/GetAnyPlan`,

  // dropdowns
  getEquipments: `${rootConfig.apiRoot1}/Schedule/AllEquipments`,
  getEquipmentsAsset: `${rootConfig.apiRoot1}/Schedule/GetEquipmentTree`,
  allScheduleTypes: `${rootConfig.apiRoot1}/Schedule/AllScheduleTypes`,
  allActivityTypes: `${rootConfig.apiRoot1}/Schedule/AllActivities`,
  MDScheduleType: `${rootConfig.apiRoot1}/Schedule/MDScheduleType`,
  frequencyType: `${rootConfig.apiRoot1}/Schedule/ScheduleTypeFrequency`,
  CreateScheduleJO: `${rootConfig.apiRoot2}/WF/CreateScheduleJO`,

  // Remarks api
  updateRemarks: `${rootConfig.apiRoot1}/User/UpdateRemarks`,
  getRemarks: `${rootConfig.apiRoot1}/User/GetRemarks/`,

  // post from modal
  addPartAdd: `${rootConfig.apiRoot2}/WF/AddPartAdd/`,
  ExchangePartAdd: `${rootConfig.apiRoot2}/WF/ExchangePartAdd`,
  // getAsset
  GetJobSpares: `${rootConfig.apiRoot1}/User/GetJobSpares/`,
  // exchange parts
  exchangeParts: `${rootConfig.apiRoot1}/User/GetJobSpares/`,
  // delete attachment in wosidepanel -post
  deleteDocument: `${rootConfig.apiRoot2}/WF/DeleteDocument`,

  // user management
  getUsersList: `${rootConfig.apiRoot}/getUsersList`,
  getUsersListNew: `${rootConfig.apiRoot}/getUsers`,
  // user forms
  getUserForm: `${rootConfig.apiRoot}/getFormStructure/UserForm`,
  getUserUpdateForm: `${rootConfig.apiRoot}/getFormStructure/UpdateUserForm`,
  getChangePasswordForm: `${rootConfig.apiRoot}/getFormStructure/ChangePasswordUserForm`,
  getProfileUserForm: `${rootConfig.apiRoot}/getFormStructure/ProfileUserForm`,
  // save user details
  updateProfileDetails: `${rootConfig.apiRoot}/updateUserDetails/profile`,
  createUserDetails: `${rootConfig.apiRoot}/updateUserDetails/new`,
  updateUserDetails: `${rootConfig.apiRoot}/updateUserDetails/update`,
  passwordUser: `${rootConfig.apiRoot}/updateUserDetails/password`,

  // Equipments View
  getEquipmentList: `${rootConfig.apiRoot1}/User/getEquipments`,
  getEquipmentDetail: `${rootConfig.apiRoot1}/User/getEquipmentDetails`,
  getEquipmentForm: `${rootConfig.apiRoot1}/User/getFormStructure`,
  updateEquipment: `${rootConfig.apiRoot1}/User/updateEquipment`,

  // For Localization
  listAvailableLanguages: `${rootConfig.baseUrl2}/ListAvailableLanguages`,
  listLangauageLabelText: `${rootConfig.baseUrl2}/ListLangauageLabelText`,
  updateUserLanguagePreference: `${rootConfig.baseUrl2}/UpdateUserLanguagePreference`,
  getUserLanguagePreference: `${rootConfig.baseUrl2}/GetUserLanguagePreference`,
  addUpdateLangauageLabelText: `${rootConfig.baseUrl2}/AddUpdateLangauageLabelText`,

  // Profile view
  getProfileList: `${rootConfig.apiRoot1}/User/getSpares`,
  updateSpare: `${rootConfig.apiRoot1}/User/updateSpare`,
  getProfileSpareDetails: `${rootConfig.apiRoot1}/User/GetSpareDetails`,

  getMasterCheckList: `${rootConfig.apiRoot1}/Checklist/GetDailyMasterChecklist`,
  getRepoCheckList: `${rootConfig.apiRoot1}/Checklist/GetDailyJobChecklist`
};
